import http from "../helpers/http-common";

class FinancialsStatsDataService {
    getTodayStats() {
        return http.get("/finance/today-stats");
    }
}

export default new FinancialsStatsDataService();